<template>
  <a
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    class="text-blue-500 hover:underline"
  >
    <slot />
  </a>
</template>

<script setup>
import { ref } from 'vue';
defineProps({
  href: {
    type: String,
    required: true,
  },
});
</script>
